import { render } from "./TeamPanel.vue?vue&type=template&id=bde3de8c&scoped=true"
import script from "./TeamPanel.vue?vue&type=script&lang=js"
export * from "./TeamPanel.vue?vue&type=script&lang=js"

import "./TeamPanel.vue?vue&type=style&index=0&id=bde3de8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde3de8c"]])

export default __exports__